import { Media, MediaStatus, MediaType } from './media'

export interface Vault {
  id: number
  uid: number
  media: string
  thumbnail: string
  duration: number
  width: number
  height: number
  pic_number: number
  pic_width: string
  pic_height: string
  price: number
  type: MediaType
}

export const DEFAULT_VAULT_MEDIA_TYPE = 'all'
export type VaultMediaTypeOptionValue = MediaType | 'all'
export const vaultMediaTypeOptions: {
  value: VaultMediaTypeOptionValue
  label: string
}[] = [
    {
      value: 'all',
      label: 'All',
    },
    {
      value: MediaType.Image,
      label: 'Photo',
    },
    {
      value: MediaType.GIF,
      label: 'GIF',
    },
    {
      value: MediaType.Video,
      label: 'Video',
    },
    {
      value: MediaType.Audio,
      label: 'Audio',
    },
  ]
export const getVaultMediaTypeLabel = (value: MediaType | undefined) =>
  vaultMediaTypeOptions.find((item) => item.value === value)?.label

export interface VaultMediaTypeStats {
  hasPhoto: boolean
  hasVideo: boolean
  hasGif: boolean
  hasAudio: boolean
}

export const convertVaultResponseToMedias = (vault: Vault): Media[] => {
  const { id, type, media, width, height, pic_width, pic_height, thumbnail } = vault
  if (type === MediaType.Video) {
    return [{
      id,
      status: MediaStatus.Ready,
      type,
      src: media,
      thumbnail,
      width,
      height,
    }]
  }

  return media.split(',').map((url, index) => {
    return {
      // temp id, there's no unique media id in post response
      id: Number(`${id}0000${index}`),
      status: MediaStatus.Ready,
      type,
      src: url,
      width: Number(pic_width),
      height: Number(pic_height),
    }
  })
}